module.exports = __webpack_public_path__ + "static/media/caregiver_tip_1.cd08cbf8.png";